import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Map, List } from 'immutable';
import { Dropdown } from '@els/els-react--dropdown';
import Catalyst from '@Services/Catalyst';
import cn from 'classnames';
import { SORT_BY_SIMILARITY_FIELD } from '@Constants';
import ResultsInfo from '@Services/ResultsInfo';
import LeftOrderButtons from './LeftOrderButtons';

import './SortBy.custom.scss';
import './SortBy.theme.scss';

function getClickHandler(spec) {
  const { item, sort, order, setSorting } = spec;
  const valueFromItem = item.get('value');
  let orderFromItem = order;

  if (sort === valueFromItem) {
    orderFromItem = orderFromItem === 'desc' ? 'asc' : 'desc';
  } else if (valueFromItem === 'IDE.NUMREF' || valueFromItem === SORT_BY_SIMILARITY_FIELD) {
    orderFromItem = item.get('order');
  }

  return () => {
    setSorting(valueFromItem, orderFromItem);
  };
}

export function SortBy({
  context,
  sortingProperties,
  currentSortingPropertiesBySortValue,
  uncheckAllItems,
  sort,
  setSorting,
  order,
  isTgitemsContext,
}) {
  useEffect(() => {
    ResultsInfo.updateResultInfoSortAndOrder(sort, order);
  }, [sort, order]);

  if (!sortingProperties || !currentSortingPropertiesBySortValue) {
    return null;
  }

  const options = sortingProperties
    .map((item) => ({
      label: item.get('title'),
      value: item.get('value'),
      id: item.get('value'),
      item,
    }))
    .toArray();
  const selectedOption = options.find((option) => currentSortingPropertiesBySortValue.get('value') === option.value);

  const onChange = (option) => {
    getClickHandler({
      item: option.item,
      sort,
      setSorting,
      order,
    })();
    uncheckAllItems();
  };
  const onToggle = (isOpen) => {
    if (isOpen) {
      Catalyst.trackProductFeature(`${Catalyst.getPrefix()}:results:${context}:sorting selector opened`);
    }
  };
  const currentTitle = `Sort by ${currentSortingPropertiesBySortValue.get('title')}`;

  return (
    <div className={cn('result-toolbar-sort-by')}>
      <Dropdown
        id="sort-by-dropdown"
        options={options}
        e2eName="result-toolbar-sort-by"
        selected={selectedOption}
        label={currentTitle}
        onChange={onChange}
        showSelectedAsLabel={false}
        flyoutProps={{
          placement: 'bottom-end',
          onToggle,
        }}
      />
      <LeftOrderButtons
        item={selectedOption.item}
        setSorting={setSorting}
        sort={sort}
        order={order}
        size={options.size}
        isTgitemsContext={isTgitemsContext}
      />
    </div>
  );
}

SortBy.propTypes = {
  context: PropTypes.string,
  sortingProperties: PropTypes.instanceOf(List),
  currentSortingPropertiesBySortValue: PropTypes.instanceOf(Map),
  uncheckAllItems: PropTypes.func.isRequired,
  sort: PropTypes.string,
  setSorting: PropTypes.func,
  order: PropTypes.string,
  isTgitemsContext: PropTypes.bool,
};

export default SortBy;
